var markers = [];
var scrollAnimationSpeed = 600;

function cityPage() {

    $('.map-pointer').click(function () {
        var menuHeight = $('.menu').height();
        $('html, body').animate({
            scrollTop: $("#school_map").offset().top - menuHeight
        }, scrollAnimationSpeed);
        var order = $(this).data("marker");

        new google.maps.event.trigger(markers[order], 'click');
    });

}

function scrollBack(schoolId) {
    var menuHeight = $('.menu').height();
    $('html, body').animate({
        scrollTop: $("#school" + schoolId).offset().top - menuHeight - 42
    }, scrollAnimationSpeed);
}

//GOOGLE MAP FOR SCHOOL
function initMap() {
    var mapZoom = 16;
    var map = new google.maps.Map(document.getElementById('school_map'), {
        scrollwheel: false,
    });


    var marker, i;
    var bounds = new google.maps.LatLngBounds();
    var infowindow = new google.maps.InfoWindow();
    for (i = 0; i < locations.length; i++) {
        var markerData = locations[i];
        marker = new google.maps.Marker({
            position: new google.maps.LatLng(markerData.lat, markerData.lng),
            map: map,
            visible: true,
            icon: {
                url: base_url + '/img/map_pointer.png'
            }
        });
        markers.push(marker);
        addMarkerContent(marker, map, markerData, infowindow);
        bounds.extend(marker.getPosition());
    }

    google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
        if (this.getZoom() > mapZoom) {
            this.setZoom(mapZoom);
        }
    });

    map.fitBounds(bounds);

}

function addMarkerContent(marker, map, markerData, infowindow) {
    google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent('<div onclick=scrollBack(' + markerData.schoolId + ')>' + markerData.schoolName + '<br>' + markerData.schoolAddress + '</div>');
        infowindow.open(map, this);
    });
}




